import InventoryListingImage from './InventoryListingImage';
export default InventoryListingImage;